import React, { Component } from 'react';
import { connect } from 'react-redux';
import ControlService from '../../helper/controlservice';
import * as formsAction from "../../redux/actions/formsAction";
import * as Actions from "../../redux/actions/loginAction";

import Elavon from '../../helper/component/Payment/Elavon';
import Stripe from '../../helper/component/Payment/Stripe';
import { settings } from '../../config/settings';
import { loadStripe } from '@stripe/stripe-js';

function mapStateToProps(state) {
    return {
        data: state.formDataReducer,
        token: state.formLoginReducer.token,
        isSidebarOpened: state.formDataReducer.isSidebarOpened,
        isModelOpened: state.formDataReducer.isModelOpened,
        sidebarFormId: state.formDataReducer.sidebarFormId,
    };
}
function bindAction(dispatch) {
    return {
        dataIsLoading: (bool) => dispatch(formsAction.dataIsLoading(bool)),
        update: (key, value, storekey) => dispatch(formsAction.updateData(key, value, storekey)),
        resetModelPopup: (data) => dispatch(formsAction.resetModelPopup(data)),
        setModelFormId: (data) => dispatch(formsAction.setModelFormId(data)),
        setSidebarFormId: (data) => dispatch(formsAction.setSidebarFormId(data)),
        setPageParams: (data) => dispatch(formsAction.setPageParams(data)),
        setreload: (bool) => dispatch(formsAction.setreload(bool)),
        authSetToken: (data) => dispatch(Actions.authSetToken(data)),
        resetSidebar: (data) => dispatch(formsAction.resetSidebar(data)),
        resetData: (data, storekey) => dispatch(formsAction.resetFormData(data, storekey)),
    };
}
class PaymentUI extends Component {
    state = {
        QueryParams: [],
        message: '',
        isApiCalling: true,
        stripePromise: null
    }
    componentDidMount() {
        const { control } = this.props;
        if (control.integrationtype === 'stripe') {
            this.setState({ isApiCalling: true });
            let _control = {
                method: settings.METHOD.GET,
                datasource: settings.DATASOURCE.HTTP
            }
            ControlService().ServiceRequest(settings.KEY_VAULT_API, { id: 'stripekey' }, _control, this.props.token, null, null)
                .then(res => {
                    let data = res.data ? res.data : {};
                    data = JSON.parse(data);

                    let _keyvalutCredential = {};
                    let stripeapidata = JSON.parse(data['stripekey']);
                    _keyvalutCredential = { stripekey: stripeapidata['Name'], publishablekey: stripeapidata['publishablekey'] };
                    this.setState({ isApiCalling: false, stripePromise: loadStripe(_keyvalutCredential.publishablekey) });
                }).catch(err => {
                    // toast.error(<Message icon="fa fa-thumbs-down" message="Failed, Please try again" type="error" />)
                    this.setState({ isApiCalling: false })
                });
        }
        if (control.mode === 'response') {
            const urlSearchParams = new URLSearchParams(window.location.search);
            var params = Object.fromEntries(urlSearchParams.entries());

            this.setState({ QueryParams: params }, () => this.savePaymentResponse());
        }
    }
    savePaymentResponse() {
        const { control } = this.props;
        const { QueryParams } = this.state;
        let message = '';
        var apiParam = {};
        Object.keys(QueryParams).forEach(key => {
            var item = control.paramlist.find(x => x.value == key);
            if (item) {
                apiParam[item.key] = QueryParams[key];
            } else {
                apiParam[key] = QueryParams[key];
            }
            if (key === 'ssl_result_message') {
                message = QueryParams[key];
                // if (QueryParams[key] == 'DECLINED') {
                //     message = control.declinemessage
                // } else if (QueryParams[key] == 'COMPLETED') {
                //     message = control.successmessage
                // }
            }
        });
        this.setState({ message: message });
        this.props.dataIsLoading(true);
        ControlService().ServiceRequest(control.Api, {}, control, this.props.token, JSON.stringify(apiParam), null, null, null, this.props)
            .then(res => {
                this.props.dataIsLoading(false);
            })
            .catch(err => {
                this.props.dataIsLoading(false);
                console.log(err.message);
            });
    }
    launchOnClick(control) {
        const { QueryParams } = this.state;
        var url = control.buttonredirecturl;
        if (control.dynamicurlparam && QueryParams[control.dynamicurlparam]) {
            url = QueryParams[control.dynamicurlparam];
        }
        if (Array.isArray(control.responsefield) && control.responsefield.length > 0) {
            var QueryStr = control.responsefield
                .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(QueryParams[k]))
                .join('&');
            url = url + '?' + QueryStr;
        }
        if (control.redirecttype === 'sametab') {
            window.open(url, '_self');
        } else if (control.redirecttype === 'newtab') {
            window.open(url, '_blank');
        } else {
            window.open(url, '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,top=50,left=100,width=1200,height=700')
        }
    }
    render() {
        var props = this.props;
        const { control } = this.props;
        var customStyle = {};
        if (control.styles) {
            try {
                customStyle = JSON.parse(control.styles);
            } catch {
                customStyle = {};
            }
        }
        if (control.mode === 'payment') {
            return (
                control.integrationtype === 'elavon' ?
                    <Elavon {...props} />
                    : control.integrationtype === 'stripe' && this.state.stripePromise ?
                        <Stripe {...props} stripePromise={this.state.stripePromise} />
                        : null
            );
        } else if (control.buttonredirecturl) {
            return (
                <>
                    <h3>{this.state.message}</h3>
                    <button aria-label='Payment' data-tip data-for={control.id} onClick={(e) => {
                        e.preventDefault();
                        this.launchOnClick(control);
                    }}
                        className={' btn ' + control.coutomClass + ' btn-' + control.buttontype + ' btn-' + control.size}
                        style={customStyle}
                    >
                        {control.WebIcon &&
                            <i className={control.WebIcon + (control.label ? ' mr-2' : '')}></i>
                        }
                        {control.bindbuttonlabelwithdata ? data[control.key] : control.label}

                    </button>
                </>
            );
        } else {
            return null;
        }
    }
}

export default connect(
    mapStateToProps, bindAction
)(PaymentUI);